import { Component, Input, OnInit } from '@angular/core';

import { AssignmentBillingItemModel } from '../../models/assignment-billing-item.model';

@Component({
    selector: 'app-billed-assignment-item',
    templateUrl: './billed-assignment-item.component.html',
    styleUrl: './billed-assignment-item.component.scss'
})
export class BilledAssignmentItemComponent {
    @Input({ required: true }) item!: AssignmentBillingItemModel;

    constructor() { }

    protected isAssignmentOnSameDay(from: Date | undefined, to: Date | undefined): boolean {
        if (!from || !to) return false;
        return new Date(from).toDateString() === new Date(to).toDateString();
    }
}
